import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import {getIcon, IconType} from '../icons-storage';

@Component({
    selector: 'lib-icon',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./icon.component.css']
})
export class IconComponent implements OnChanges {
    constructor(
        er: ElementRef,
        private readonly renderer: Renderer2,
    ) {
        this.native = er.nativeElement;
    }

    @Input() type: IconType;

    /**
     * Размер в px
     */
    @Input() size: number;

    /**
     * Цвет иконки
     * Если явно не указано, будет использован fill цвет родителя или отобразится черным по умолчанию
     */
    @Input() color: string;

    /**
     * Если иконка находится в тексте, то ее размер будет задан самим компонентом
     */
    @Input() isInText = false;

    /**
     * Выравнивание иконки
     */
    @Input() align: 'baseline' | 'bottom' | 'top' | 'middle' = 'baseline';

    private readonly native: HTMLElement;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.type) {
            const icon = getIcon(this.type);
            if (icon) {
                this.setSVGFromString(icon);
            }
            this.setHeight();
        }

        if (changes.color) {
            this.setColor();
        }

        this.setAlign();

    }

    private setSVGFromString(data: string) {
        this.native.innerHTML = data;
    }

    private setHeight() {
        const heightValue = this.isInText ? '0.75em' : (this.size ? this.size + 'px' : '1em');
        this.renderer.setStyle(this.native, 'height', heightValue);
    }

    private setAlign() {
        this.renderer.setStyle(this.native, 'vertical-align', this.align);
    }

    private setColor() {
        this.renderer.setStyle(this.native, 'fill', this.color);
    }
}
